import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon, langPage } from "../../../locales";
import { MemberServer } from "../../../server";
import { generateAmountOperationFormConfig } from './config'

const server = MemberServer.User;
const lang = langPage?.member?.user;

const DEFAULT_OPERATION_DATA = {
    Amount: null,
    MemberId: null,
    WalletType: 1,
    Remark: null
}

type OperateModeType = 'add' | 'reduce'

export const Amount = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('add');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.updateAmount, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.operateSuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateAmountOperationFormConfig({ formData, mode });
    }, [formData, mode]);

    return (
        <div>
            <Modal
                title={`${mode === 'add' ? lang?.addAmount : lang?.reduceAmount}`}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Amount, WalletType, MemberId, Remark } = formData
                    const amount = mode === 'add' ? Amount : -Amount
                    const params = {
                        Amount: amount,
                        WalletType,
                        MemberId,
                        Remark
                    }
                    run(params)
                }}
            >
                <EditForm
                    componentId="user-amount"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 8 },
                        wrapperCol: { span: 12 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
